import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const KpiPieChart = ({ data, title }) => {
  // Generate colors using golden angle approximation (matches preview implementation)
  const generateColors = (count) => {
    return Array.from({ length: count }, (_, index) => {
      const hue = (index * 137.508) % 360; // Golden angle approximation
      return `hsl(${hue}, 70%, 60%)`;
    });
  };

  // Modify data for pie chart with multiple colors
  const pieData = {
    ...data,
    datasets: data.datasets?.map(dataset => ({
      ...dataset,
      backgroundColor: Array.isArray(dataset.backgroundColor) 
        ? dataset.backgroundColor 
        : (dataset.seriesColor 
          ? [dataset.seriesColor] 
          : generateColors(data.labels?.length || 0)),
      borderColor: '#fff',
      borderWidth: 1,
    })) || []
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
      },
      title: {
        display: !!title,
        text: title,
      },
    },
  };

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <Pie data={pieData} options={options} />
    </div>
  );
};

export default KpiPieChart;
